import { Star } from 'lucide-react'
import type { PickBadge, PickBadgeTone } from '@/data/article-product-picks'

const TONE_CLASSES: Record<PickBadgeTone, string> = {
  gold: 'bg-amber-100 text-amber-900 ring-amber-300',
  green: 'bg-emerald-100 text-emerald-900 ring-emerald-300',
  blue: 'bg-sky-100 text-sky-900 ring-sky-300',
  purple: 'bg-violet-100 text-violet-900 ring-violet-300',
  orange: 'bg-orange-100 text-orange-900 ring-orange-300',
  slate: 'bg-slate-100 text-slate-800 ring-slate-300',
}

interface PickBadgePillProps {
  badge: PickBadge
  size?: 'sm' | 'md'
  // Blog product-callout redesign shows a leading star glyph on the pick badge. Scoped/off by
  // default so the tool cards + affiliate-card-block that also use this pill are unaffected.
  showStar?: boolean
}

export function PickBadgePill({ badge, size = 'md', showStar = false }: PickBadgePillProps) {
  const tone = TONE_CLASSES[badge.tone ?? 'green']
  const sizing = size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-2.5 py-0.5'
  // Keyed off tier (not the now-freely-editable label); legacy verdict picks that still carry a
  // rating but no tier keep their stars via the rating check.
  const showRating = (badge.tier === 'verdict' || typeof badge.rating === 'number') && typeof badge.rating === 'number'

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full ring-1 font-semibold uppercase tracking-wide ${sizing} ${tone}`}
    >
      {showStar && !showRating && <Star className="w-3 h-3 fill-current" aria-hidden="true" />}
      {badge.label}
      {showRating && (
        <span className="inline-flex items-center gap-0.5 normal-case">
          <Star className="w-3 h-3 fill-current" aria-hidden="true" />
          {badge.rating!.toFixed(1)}/5
        </span>
      )}
    </span>
  )
}
